module.exports = __webpack_public_path__ + "img/view-profs.9ebaa0b1.svg";